import { FC } from 'react';
import { connect, DispatchProp } from 'react-redux';
import { userCloseContextMenu } from '../../../actions';
import { RootState } from '../../../reducers';
import { openWindowAppEmptyLeg2020 } from '../../../utils';
import { hasPermission } from '../../../utils/check-permissions';
import { ContextMenuSimpleWrapper } from '../wrappers';
import { Action } from 'typescript-fsa';

interface StateProps {
  hasEditEventPermission: boolean;
  isOpen: boolean;
  position: { x: number; y: number };
  id: number;
}

const EmptyLegOfferContextMenu: FC<StateProps & DispatchProp<Action<void>>> = ({
  hasEditEventPermission,
  id,
  isOpen,
  dispatch,
  position,
}) => {
  const onEdit = () => {
    dispatch(userCloseContextMenu());
    openWindowAppEmptyLeg2020({ id });
  };
  if (!isOpen || !hasEditEventPermission) return null;
  return (
    <ContextMenuSimpleWrapper position={position}>
      <li onClick={onEdit}>Edit</li>
    </ContextMenuSimpleWrapper>
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  isOpen: state.emptyLegOfferController.contextMenu.isOpen,
  position: state.emptyLegOfferController.contextMenu.position,
  hasEditEventPermission: hasPermission(state, 'AG-Timeline-View-EL-Offer'),
  id: state.emptyLegOfferController.id,
});

export const EmptyLegOfferContextMenuConnected = connect(mapStateToProps)(
  EmptyLegOfferContextMenu
);
